<template>
  <div :class="(boxStyle != false) ? 'box box-primary' : ''">
    <div class="box-body">
      <!-- Search Filter -->
      <div
        v-if="useFilterSelect"
        style="display:-webkit-box;margin:5px 20px;float:right;border:0px solid red;text-align:right;display: flex; justify-content: flex-end;margin-right: 0px"
      >
        <div style="margin-right: 2px;">
          <span
            style="justify-content: center;font-size:20px; padding: 10px;border: 1px solid #e5e5e5;border-radius: 5px;"
            class="fa fa-search"
          ></span>
        </div>
        <multiselect
          v-model="paymentStatusSelected"
          :placeholder="$t('common.status')"
          label="text"
          track-by="id"
          :multiple="true"
          :options="paymentStatusOptions"
          :showLabels="false"
          :maxHeight="200"
          style="width:250px;"
        ></multiselect>
      </div>
      <div
        v-show="useFilter"
        class="input-group input-group-sm"
        :class="[search_filter,isVisibility]"
      >
        <input
          type="text"
          name="query"
          @input="filterDataOnTable"
          v-model="searchQuery"
          class="form-control pull-right"
          :placeholder="$t('common.search')"
        />

        <div class="input-group-btn">
          <button type="submit" class="btn btn-default">
            <i class="fa fa-search"></i>
          </button>
        </div>
      </div>
      <!-- Table -->
      <div style="overflow: auto;width:100%;">
        <table class="table table-bordered" style="width: 100%;border:0px solid;">
          <tbody>
            <!-- Header and Border Default -->
            <ul
              v-if="hdBackground == undefined"
              style="display:contents;margin: 0;padding: 0; border:0px solid;"
            >
              <!-- Add Header CheckBox -->
              <th v-if="useCheckBox" :style="headerDefaultBackground" style="text-align:center;">
                <!-- <b-form-checkbox></b-form-checkbox> -->
                <input type="checkbox" v-model="selectAll" @change="select" />
              </th>
              <!-- Add Header CheckBox -->
              <!-- v-for="key in columns" -->
              <!-- @click="sortBy(key)"-->
              <th
                :style="headerDefaultBackground"
                v-for="key in columns"
                :class="{ active: sortKey == key }"
                :key="key.id"
              >
                {{ $t(key) | capitalize }}
                <!--
                <span
                  v-if="arrow != undefined"
                  :class="[sortOrders[key] > 0 ? 'asc' :'dsc', arrow]"
                ></span>
                <span v-else class="arrow" :class="[sortOrders[key] > 0 ? 'asc' :'dsc']"></span>
                -->
              </th>
            </ul>
            <!-- Header and Border Defined -->
            <ul
              v-if="hdBackground != undefined"
              style="display:contents;
              margin: 0;
              padding: 0;
              border:1px solid;"
            >
              <!-- Add Header CheckBox -->
              <th v-if="useCheckBox"
                :style="hdBackground"
                style="width:55px;text-align:center;white-space:nowrap">
                <!-- <b-form-checkbox></b-form-checkbox> -->
                <input type="checkbox" v-model="selectAll" @change="select" />
              </th>
              <!-- Add Header CheckBox -->
              <!-- @click="sortBy(columns[0]['text'] ? key.text : key)"-->
              <th
                v-for="key in columns"
                v-show="(columns[0]['text']) ? key.isHidden : true"
                :class="{ active: sortKey == (columns[0]['text'] ? key.text : key ) }"
                :key="key.id"
                white-space: nowrap
                style="text-align:center;"
                :style="{
                  backgroundColor: '#4b646f',
                  color:'white',
                  border:'1px solid white',
                  'min-width': key.width ? key.width : 0,
                  width: (columns[0]['text'] ? key.text : key ) == 'common.nonumber' ? '60px' : ''
                }"
              >
                {{ (columns[0]['text']) ? $t(key.text) : $t(key) | capitalize }}
                <!--
                <span
                  v-if="arrow != undefined"
                  :class="[sortOrders[(columns[0]['text']) ? key.text : key] > 0 ? 'asc' :'dsc', arrow]"
                ></span>
                <span
                  v-else
                  class="arrow"
                  :class="[sortOrders[(columns[0]['text']) ? key.text : key] > 0 ? 'asc' :'dsc']"
                ></span>
                -->
              </th>
            </ul>

            <th
              v-if="views != undefined && hdBackground == undefined"
              :style="headerDefaultBackground"
              style="text-align:center;white-space:nowrap"
            >{{$t('common.preview')}}</th>
            <th
              v-if="views != undefined && hdBackground != undefined"
              :style="hdBackground"
              style="text-align:center;white-space:nowrap"
            >{{$t('common.preview')}}</th>
            <th
              v-if="actions != undefined && hdBackground == undefined"
              :style="headerDefaultBackground"
              style="text-align:center;white-space:nowrap"
            >{{$t('common.action')}}</th>
            <th
              v-if="actions != undefined && hdBackground != undefined"
              :style="hdBackground"
              style="text-align:center;white-space:nowrap;width:100px"
            >{{$t('common.action')}}</th>
            <!-- Aadd Data -->
            <ul
              v-if="tblBorder == undefined"
              style="display: contents;margin:0;padding: 0; border:1px solid red;"
            >
              <!-- :class="{ active: sortKey == key }" -->
              <tr
                :style="tableBorder"
                v-for="entry in filteredData"
                :key="entry.id"
                :uId="entry.id"
                :class="{
                  active_line: (getStatusField == true) ? (status_field[statusField] == entry[statusField]  ? true : false ) : false,
                  row_mouse_pointer: row_mouse_pointer}"
              >
                <!-- <td v-for="key in columns" :style="tableBorder" :key="key.id">{{entry[key]}}</td> -->
                <!-- Add Column CheckBox -->
                <td v-if="useCheckBox"
                  style="width:2%;text-align:center;"
                  :style="`background: ${entry['backgroundRow'] !== undefined ? entry['backgroundRow'] : ''}`">
                  <!-- <b-form-checkbox v-model="checkIdItems" :value="entry.id" id="entry.id" @change="checkItems(entry.id)"></b-form-checkbox> -->
                  <!-- <input
                    v-if="entry['apartment.status'] == 'Bàn Giao' || entry['apartment.status'] == 'Handover'"
                    disabled
                    type="checkbox"
                    :value="isGetInformationInvoice != undefined && isGetInformationInvoice ? entry : entry.id"
                    id="entry.id"
                    v-model="selected"
                    @change="checkItems($event)"
                  />-->
                  <input
                    type="checkbox"
                    :value="isGetInformationInvoice != undefined && isGetInformationInvoice ? entry : entry.id"
                    id="entry.id"
                    v-model="selected"
                    :disabled="entry['disableCheckbox'] !== undefined ? entry['disableCheckbox'] : null"
                    @change="checkItems($event)"
                  />
                </td>
                <!-- Add Column CheckBox -->
                <!-- v-for="header_key in columns" -->
                <!--:style="tableBorder"-->
                <td
                  v-for="header_key in columns"
                  v-show="(columns[0]['text']) ? header_key.isHidden : true"
                  :key="(columns[0]['text']) ? header_key.text.id : header_key.id"
                  @click="onClickItemRow(entry.id)"
                  :style="{
                    border: '1px solid #f4f4f4',
                    textAlign: header_key.align ? header_key.align : ((columns[0]['text'] ? header_key.text : header_key ) == 'common.nonumber' ? 'center' :
                      isNumber(entry[ (columns[0]['text']) ? header_key.text : header_key ]) ||
                      isDateString(entry[ (columns[0]['text']) ? header_key.text : header_key ]) ? 'right' :  'left'),
                    'white-space': header_key.wrapText ? header_key.wrapText : '',
                    padding:((columns[0]['text'] ? header_key.text : header_key ) == 'user.is_active' ? '5px 7px 0px 30px' : ''),
                    background: entry['backgroundRow'] !== undefined ? entry['backgroundRow'] : ''
                  }"
                >
                  <span v-if="useCheckBox">
                    <b-form-checkbox v-if="header_key == 'id'"></b-form-checkbox>
                  </span>
                  <!-- Email Agent List -->
                  <span v-if="getCustomColumns">
                    <div
                        v-if="Object.keys(customColumns).includes((columns[0]['text']) ? header_key.text : header_key) && ( (columns[0]['text'] ? header_key.text : header_key) == 'email_history_agent.content' || (columns[0]['text'] ? header_key.text : header_key) == 'email_history_agent.content' || (columns[0]['text'] ? header_key.text : header_key) == 'email_history_agent.content')"
                        >
                        <div v-html="entry[ (columns[0]['text']) ? header_key.text : header_key ]"></div>
                        </div>
                  </span>
                  <!-- End Email Agent List -->
                  <span v-if="getCustomColumns">
                    <!-- {{(columns[0]['text']) ? header_key.text : header_key}} -->
                    <span
                      v-if="Object.keys(customColumns).includes((columns[0]['text']) ? header_key.text : header_key) &&
                      (columns[0]['text'] ? header_key.text : header_key) == 'invoice.status_name'"
                      :class="[
                      {'label': customColumns[`${(columns[0]['text']) ? header_key.text : header_key}`][entry[ (columns[0]['text']) ? header_key.text : header_key ]]},
                                customColumns[`${(columns[0]['text']) ? header_key.text : header_key}`][entry[ (columns[0]['text']) ? header_key.text : header_key ]]]"
                    >{{ entry[ (columns[0]['text']) ? header_key.text : header_key ]}}</span>
                    <span v-else>
                      <!-- BEGIN - user.is_active -->
                      <span
                        v-if="Object.keys(customColumns).includes((columns[0]['text']) ? header_key.text : header_key) &&
                      (columns[0]['text'] ? header_key.text : header_key) == 'user.is_active'"
                        :class="[
                        {'btn-label': customColumns[`${(columns[0]['text']) ? header_key.text : header_key}`][entry[ (columns[0]['text']) ? header_key.text : header_key ]]},
                                  customColumns[`${(columns[0]['text']) ? header_key.text : header_key}`][entry[ (columns[0]['text']) ? header_key.text : header_key ]]]"
                      ></span>

                      <!-- END - user.is_active -->

                      <!-- Apartment Code -->
                      <span
                        v-else-if="Object.keys(customColumns).includes((columns[0]['text']) ? header_key.text : header_key) &&
                      (columns[0]['text'] ? header_key.text : header_key) == 'invoice.apartment_code'"
                        :class="[
                      {'label': customColumns['invoice.status_name'][entry[ 'invoice.status_name']]},
                                customColumns['invoice.status_name'][entry[ 'invoice.status_name' ]]]"
                      >{{ entry[ (columns[0]['text']) ? header_key.text : header_key ]}}</span>
                      <!-- Total Fees -->
                      <span
                        v-else-if="Object.keys(customColumns).includes((columns[0]['text']) ? header_key.text : header_key) &&
                      (columns[0]['text'] ? header_key.text : header_key) == 'invoice.total_fees'"
                        :class="[
                      {'label': customColumns['invoice.status_name'][entry['invoice.status_name']]},
                                customColumns['invoice.status_name'][entry['invoice.status_name']]]"
                      >{{ entry[ (columns[0]['text']) ? header_key.text : header_key ]}}</span>

                      <span
                        v-else-if="Object.keys(customColumns).includes((columns[0]['text']) ? header_key.text : header_key) && entry[ (columns[0]['text']) ? header_key.text : header_key ] == $t('apartment.open')"
                        :class="[{'label': customColumns[`${(columns[0]['text']) ? header_key.text : header_key}`]['apartment.open']}, customColumns[`${(columns[0]['text']) ? header_key.text : header_key}`]['apartment.open']]"
                      >{{ entry[ (columns[0]['text']) ? header_key.text : header_key ]}}</span>
                      <span
                        v-else-if="Object.keys(customColumns).includes((columns[0]['text']) ? header_key.text : header_key) && entry[ (columns[0]['text']) ? header_key.text : header_key ] == $t('apartment.issue')"
                        :class="[{'label': customColumns[`${(columns[0]['text']) ? header_key.text : header_key}`]['apartment.issue']}, customColumns[`${(columns[0]['text']) ? header_key.text : header_key}`]['apartment.issue']]"
                      >{{ entry[ (columns[0]['text']) ? header_key.text : header_key ]}}</span>
                      <span
                        v-else-if="Object.keys(customColumns).includes((columns[0]['text']) ? header_key.text : header_key) && entry[ (columns[0]['text']) ? header_key.text : header_key ] == $t('apartment.paid')"
                        :class="[{'label': customColumns[`${(columns[0]['text']) ? header_key.text : header_key}`]['apartment.paid']}, customColumns[`${(columns[0]['text']) ? header_key.text : header_key}`]['apartment.paid']]"
                      >{{ entry[ (columns[0]['text']) ? header_key.text : header_key ]}}</span>

                      <!--span
                      v-else-if="Object.keys(customColumns).includes((columns[0]['text']) ? header_key.text : header_key) &&
                      ( (columns[0]['text'] ? header_key.text : header_key == 'invoice.date_issued') || (columns[0]['text'] ? header_key.text : header_key == 'invoice.date_paid') || (columns[0]['text'] ? header_key.text : header_key == 'invoice.due_date'))"
                      :class="[
                      {'label': (checkIsMonthCurrent(entry[ (columns[0]['text']) ? header_key.text : header_key ])) ?
                                customColumns[`${(columns[0]['text']) ? header_key.text : header_key}`]['date_curent'] :
                                customColumns[`${(columns[0]['text']) ? header_key.text : header_key}`]['date_last']},

                                ( (entry[ (columns[0]['text']) ? header_key.text : header_key ] != '') ? ( checkIsMonthCurrent(entry[ (columns[0]['text']) ? header_key.text : header_key ]) ?
                                customColumns[`${(columns[0]['text']) ? header_key.text : header_key}`]['date_curent'] :
                                customColumns[`${(columns[0]['text']) ? header_key.text : header_key}`]['date_last']) : '')]"
                      >{{ entry[ (columns[0]['text']) ? header_key.text : header_key ]}}</span-->

                      <!-- date issued, date paid, due date -->

                      <span
                        v-else-if="Object.keys(customColumns).includes((columns[0]['text']) ? header_key.text : header_key) &&
                      ( (columns[0]['text'] ? header_key.text : header_key) == 'invoice.date_issued' || (columns[0]['text'] ? header_key.text : header_key) == 'common.dateCreate' || (columns[0]['text'] ? header_key.text : header_key) == 'invoice.date_paid' || (columns[0]['text'] ? header_key.text : header_key) == 'invoice.due_date')"
                        :class="[
                      {'label': customColumns['invoice.status_name'][entry['invoice.status_name']]},
                                customColumns['invoice.status_name'][entry['invoice.status_name']]]"
                      >{{ entry[ (columns[0]['text']) ? header_key.text : header_key ]}}</span>

                      <span
                        v-else-if="Object.keys(customColumns).includes((columns[0]['text']) ? header_key.text : header_key) &&
                      (columns[0]['text'] ? header_key.text : header_key) != 'invoice.status_name'"
                        :class="[{'label': customColumns[`${(columns[0]['text']) ? header_key.text : header_key}`]}, customColumns[`${(columns[0]['text']) ? header_key.text : header_key}`]]"
                      >{{ entry[ (columns[0]['text']) ? header_key.text : header_key ]}}</span>

                      <span v-else>{{ entry[ (columns[0]['text']) ? header_key.text : header_key ]}}</span>
                    </span>
                  </span>
                  <!-- Progess -->
                  <span v-if="getCustomColumns">
                    <div
                        v-if="Object.keys(customColumns).includes((columns[0]['text']) ? header_key.text : header_key) && ( (columns[0]['text'] ? header_key.text : header_key) == 'apartment_schedule_progress.progress' || (columns[0]['text'] ? header_key.text : header_key) == 'apartment_schedule_progress.progress' || (columns[0]['text'] ? header_key.text : header_key) == 'apartment_schedule_progress.progress')"
                        :class="'progress progress-custom'">
                        <div class="progress-bar" role="progressbar" :style="'width: ' + entry[ (columns[0]['text']) ? header_key.text : header_key ]" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100">{{ entry[ (columns[0]['text']) ? header_key.text : header_key ]}}</div>
                        </div>
                      <!-- <div class="progress">
                        <div class="progress-bar progress-bar-striped" role="progressbar" style="width: 50%" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100"></div>
                      </div> -->
                  </span>
                  <!-- end  progress -->
                  <!-- add containLink -->
                  <span v-else-if="containLink">
                    <span v-if="header_key.text== 'documentation.url'">
                      <a
                        :href="entry[header_key.text]"
                        target="_blank"
                        style="color: #00c0ef"
                        :style="entry[header_key.text]?'color: #00c0ef' : 'color: #dd4b39'"
                      >{{entry['documentation.name']}}</a>
                    </span>

                    <span v-else-if="header_key.text == 'property.asset.asset_status'">
                      <b-form-select
                        v-if="header_key.text == 'property.asset.asset_status'"
                        :style="entry[header_key.text][2]"
                        :options="entry[header_key.text][1]"
                        v-model="entry[header_key.text][0]"
                        @change="changeBFormSelect(entry[header_key.text][0], entry)"
                        class="form-control"
                      />
                    </span>

                    <span
                      v-else
                    >{{(columns[0]['text']) ? entry[header_key.text] : entry[header_key]}}</span>
                  </span>
                  <span v-else>{{(columns[0]['text']) ? entry[header_key.text] : entry[header_key]}}</span>
                </td>

                <!-- Add Views -->
                <td v-if="views !=undefined">
                  <lte-hyperlink v-for="item in views" :key="item" left_icon="fa fa-eye">{{item}}</lte-hyperlink>
                </td>

                <!-- Add Actions Edit/Delete -->
                <td
                  id="actionColunm"
                  v-if="actions !=undefined"
                  style="width:fit-content;height:auto;border:0px solid green;display:table-cell"
                  :style="`background: ${entry['backgroundRow'] !== undefined ? entry['backgroundRow'] : ''}`"
                >
                  <div style="border:0px solid red;height:100%;text-align:center;">
                    <div
                      class="btn-group"
                      style="border:0px solid blue;width:auto;display:inline-flex;"
                    >
                      <button
                        id="more-btn"
                        type="button"
                        class="btn more-btn dropdown-toggle"
                        :class="colorAction !==undefined ? colorAction : 'btn-danger'"
                        data-toggle="dropdown"
                      >
                        <span class="more-dot"></span>
                        <span class="more-dot"></span>
                        <span class="more-dot"></span>
                      </button>
                      <ul
                        v-if="isCustomActions"
                        class="dropdown-menu"
                        role="menu"
                        style="min-width:70px;margin-top:0px;text-align:center;"
                      >
                        <li v-for="item in getActionCustom(actions, entry)" :key="item">
                          <lte-button
                            :key="item"
                            :type="getButtonType(item)"
                            :right_icon="getButtonIcon(item)"
                            :target="getButtonTarget(item)"
                            style="margin-left:6px;"
                            @click="getButtonClick(item, entry)"
                            :title="getButtonTitle(item)"
                          ></lte-button>
                        </li>
                      </ul>
                      <ul
                        v-else
                        class="dropdown-menu"
                        role="menu"
                        style="min-width:90px;margin-top:0px;text-align:center;"
                      >
                        <li v-for="item in actions" :key="item">
                          <lte-button
                            :key="item"
                            :type="getButtonType(item)"
                            :right_icon="getButtonIcon(item)"
                            :target="getButtonTarget(item)"
                            style="margin-left:6px;"
                            @click="getButtonClick(item, entry)"
                            :title="getButtonTitle(item)"
                          ></lte-button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </td>
              </tr>
            </ul>

            <ul
              v-if="tblBorder != undefined"
              style="display: contents;margin:0;padding: 0; border:1px solid red;"
            >
              <tr
                :style="tblBorder"
                v-for="entry in filteredData"
                :key="entry.id"
                :class="{active_line: (getStatusField == true) ? (status_field['apartment.apartment_status'] == entry['apartment.apartment_status']  ? true : false ) : false }"
              >
                <!-- <td v-for="key in columns" :style="tblBorder" :key="key.id">{{entry[key]}}</td> -->
                <!-- {{entry['apartment_status']}} -->

                <!-- Add Column CheckBox -->
                <td v-if="useCheckBox" style="width:2%;">
                  <!-- <b-form-checkbox v-model="checkIdItems" :value="entry.id" id="entry.id" @change="checkItems(entry.id)"></b-form-checkbox> -->
                  <input
                    type="checkbox"
                    :value="isGetInformationInvoice != undefined && isGetInformationInvoice ? entry : entry.id"
                    id="entry.id"
                    v-model="selected"
                    @change="checkItems($event)"
                  />
                </td>
                <!-- Add Column CheckBox -->
                <td v-for="header_key in columns" :style="tableBorder" :key="header_key.id">
                  <span v-if="getCustomColumns">
                    <span
                      v-if="Object.keys(customColumns).includes(header_key) && entry[header_key] == $t('apartment.open')"
                      :class="[{'label': customColumns[`${header_key}`]['apartment.open']}, customColumns[`${header_key}`]['apartment.open']]"
                    >{{ entry[header_key]}}</span>
                    <span
                      v-else-if="Object.keys(customColumns).includes(header_key) && entry[header_key] == $t('apartment.issue')"
                      :class="[{'label': customColumns[`${header_key}`]['apartment.issue']}, customColumns[`${header_key}`]['apartment.issue']]"
                    >{{ entry[header_key]}}</span>
                    <span
                      v-else-if="Object.keys(customColumns).includes(header_key) && entry[header_key] == $t('apartment.paid')"
                      :class="[{'label': customColumns[`${header_key}`]['apartment.paid']}, customColumns[`${header_key}`]['apartment.paid']]"
                    >{{ entry[header_key]}}</span>
                    <span
                      v-else-if="Object.keys(customColumns).includes(header_key)"
                      :class="[{'label': customColumns[`${header_key}`]}, customColumns[`${header_key}`]]"
                    >{{ entry[header_key]}}</span>
                    <span v-else>{{ entry[header_key]}}</span>
                  </span>
                  <span v-else>{{entry[header_key]}}</span>
                </td>
                <!-- Add Views -->
                <td v-if="views !=undefined">
                  <lte-hyperlink v-for="item in views" :key="item" left_icon="fa fa-eye">{{item}}</lte-hyperlink>
                </td>
                <!-- Add Actions Edit/Delete -->
                <td v-if="actions !=undefined">
                  <div class="btn-group">
                    <button
                      id="more-btn"
                      type="button"
                      class="btn more-btn dropdown-toggle"
                      :class="colorAction !==undefined ? colorAction : 'btn-danger'"
                      data-toggle="dropdown"
                    >
                      <span class="more-dot"></span>
                      <span class="more-dot"></span>
                      <span class="more-dot"></span>
                    </button>
                    <ul
                      class="dropdown-menu"
                      role="menu"
                      style="min-width:90px;margin-top:0px;text-align:center;"
                    >
                      <li v-for="item in actions" :key="item">
                        <lte-button
                          :key="item"
                          :type="getButtonType(item)"
                          :right_icon="getButtonIcon(item)"
                          :target="getButtonTarget(item)"
                          style="margin-left:6px;"
                          @click="getButtonClick(item, entry)"
                        ></lte-button>
                      </li>
                    </ul>
                  </div>
                </td>
              </tr>
            </ul>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Pagination -->
  </div>
</template>

<script>
import LTEButton from "./LTEButton.vue";
import Multiselect from "vue-multiselect";
import LTEHyperlink from "@/components/LTEHyperlink.vue";
import utils from '@/lib/utils';
import { LTEActionTypeEnum } from '@/components/LTEEnum'

export default {
  name: "lte-table",
  props: [
    "data",
    "columns",
    "actions",
    "views",
    "search_filter",
    "hdBackground",
    "tblBorder",
    "isVisibility",
    "useFilter",
    "useFilterSelect",
    "useCheckBox",
    "customColumns",
    "arrow",
    "status_field",
    "status_invoice_field",
    "row_mouse_pointer",
    "colorAction",
    "boxStyle",
    "paymentStatusOptions",
    "isGetInformationInvoice",
    "containLink",
    "isCustomActions",
    "customActionKey"
  ],
  data() {
    return {
      searchQuery: "",
      sortKey: "",
      sortOrders: {},
      recordData: {},
      LTEActionTypeEnum: LTEActionTypeEnum,
      actionsType: LTEActionTypeEnum.DEFAULT,
      tblDefaultBorder: "border: 1px solid #f4f4f4",
      hdDefaultBackground: "background-color: #008f68",
      isModalVisible: false,
      emitfilteredData: [],
      keepCheckItems: [],
      selected: [],
      paymentStatusSelected: [],
      selectAll: false,
      hdBackground1:
        "background-color: #4b646f;color:white;border:1px solid white;",
      statusField: ""
    };
  },
  watch: {
    customColumns: function() {},
    columns: function() {
      /// Column attributes
      // - text: column name
      // - isHidden: true if column is hidden
      // - align: text align, default is 'left', refer 'textAlign' for the value
      // - width: minimum witdh of columnn
      // - wrapText: text in cell is wrapped, default is 'normal', ref 'white-space' for the value
    }
  },
  computed: {
    getCustomColumns: function() {
      let isCheck = true;
      if (this.customColumns == undefined) {
        isCheck = false;
      }
      return isCheck;
    },
    getStatusField: function() {
      let isCheckStatus = false;

      if (
        this.status_field !== undefined &&
        this.status_field["apartment.apartment_status"] === 1
      ) {
        this.setStatusField("apartment.apartment_status");
        isCheckStatus = true;
      }

      if (
        this.status_field !== undefined &&
        this.status_field["exported_to_liability"] === 1
      ) {
        this.setStatusField("exported_to_liability");
        isCheckStatus = true;
      }
      return isCheckStatus;
    },
    getStatusInvoiceField: function() {
      let isCheckStatus = true;
      if (this.status_invoice_field == undefined) {
        isCheckStatus = false;
      }
      return isCheckStatus;
    },
    filteredData: function() {
      //does not this feature
      // if (!this.useFilter) {
      //   return this.data;
      // }
      let sortKey = this.sortKey;
      let filterKey = "";
      if (this.useFilter) {
        filterKey = this.searchQuery && this.searchQuery.toLowerCase().trim();
      } else if (this.useFilterSelect) {
        filterKey = this.paymentStatusSelected;
      }
      let order = this.sortOrders[sortKey] || 1;
      let data = this.data;
      if (this.useFilterSelect && filterKey.length > 0) {
        data = data.filter(function(row) {
          return Object.keys(row).some(function(key) {
            for (let i = 0, size = filterKey.length; i < size; i++) {
              if (
                String(row[key])
                  .toLowerCase()
                  .startsWith(filterKey[i].text.toLowerCase())
              ) {
                return true;
              }
            }
          });
        });
      } else if (this.useFilter && filterKey) {
        data = data.filter(function(row) {
          return Object.keys(row).some(function(key) {
            /*return (
              String(row[key])
                .toLowerCase()
                .indexOf(filterKey) > -1
            );*/
            return String(row[key])
              .toLowerCase()
              .startsWith(filterKey);
          });
        });
      }
      if (sortKey) {
        data = data.slice().sort(function(a, b) {
          a = a[sortKey];
          b = b[sortKey];
          return (a === b ? 0 : a > b ? 1 : -1) * order;
        });
      }

      this.$emit("filters", data);
      this.$emit("searchQuery", this.searchQuery);
      return data;
    },
    tableBorder: function() {
      return this.tblDefaultBorder;
    },
    headerDefaultBackground: function() {
      return this.hdDefaultBackground;
    }
  },
  filters: {
    capitalize: function(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    }
  },
  methods: {
    getButtonType(item) {
      let button_type = ""
      switch (item) {
        case 'common.modify':
          button_type = 'btn btn-primary'
          break
        case 'common.view':
          button_type = 'btn btn-info'
          // button_type = 'btn btn-warning'
          break
        case 'common.delete':
          button_type = 'btn btn-danger'
          break
        case 'common.sendPdf':
          button_type = 'btn btn-warning'
          break
        case 'common.pay':
          button_type = 'btn btn-success'
          break
        case 'common.add_retail_service':
          button_type = 'btn btn-success'
          break
        default:
          button_type = 'btn info'
          break;
      }

      return button_type
    },
    getButtonIcon(item) {
      let button_icon = ""
      switch (item) {
        case 'common.modify':
          button_icon = 'glyphicon glyphicon-edit'
          break
        case 'common.view':
          button_icon = 'fa fa-eye'
          break
        case 'common.delete':
          button_icon = 'glyphicon glyphicon-trash'
          break
        case 'common.booking':
          button_icon = 'fa fa-list-alt'
          break
        case 'common.sendPdf':
          button_icon = 'fa fa-file-pdf-o'
          break
        case 'common.pay':
          button_icon = 'fa fa-money'
          break
        case 'common.add_retail_service':
          button_icon = 'fa fa-plus'
          break
        default:
          button_icon = 'fa fa-print'
          break;
      }
      return button_icon
    },
    getButtonTarget(item) {
      let target = ""
      switch (item) {
        case 'common.modify':
          target = ''
          break
        case 'common.view':
          target = ''
          break
        case 'common.delete':
          target = ''
          break
        case 'common.sendPdf':
          target = ''
          break
        case 'common.pay':
          target = ''
          break
        case 'common.add_retail_service':
          target = ''
          break
        default:
          target = "_blank"
          break;
      }
      return target
    },
    getButtonClick(item, entry) {
      let go_to_action = ""
      switch (item) {
        case 'common.modify':
          go_to_action = this.performAction(entry, LTEActionTypeEnum.MODIFY, false)
          break
        case 'common.view':
          go_to_action = this.performAction(entry, LTEActionTypeEnum.VIEW, false)
          break
        case 'common.delete':
          go_to_action = this.performAction(entry, LTEActionTypeEnum.DELETED, true)
          break
        case 'common.booking':
          go_to_action = this.performAction(entry, LTEActionTypeEnum.BOOKING, false)
          break
        case 'common.sendPdf':
          go_to_action = this.performAction(entry, LTEActionTypeEnum.SEND_PDF, false)
          break
        case 'common.pay':
          go_to_action = this.performAction(entry, LTEActionTypeEnum.PAYMENT, true)
          break
        case 'common.add_retail_service':
          go_to_action = this.performAction(entry, LTEActionTypeEnum.ADD_RETAIL_SERVICE, true)
          break
        default:
          go_to_action = this.performAction(entry, LTEActionTypeEnum.PRINT, true)
          break;
      }
      return go_to_action
    },
    getButtonTitle(item) {
      let text_title = ""
      switch (item) {
        case 'common.modify':
          text_title = this.$t('common.modify')
          break
        case 'common.view':
          text_title = this.$t('common.view')
          break
        case 'common.delete':
          text_title = this.$t('common.delete')
          break
        case 'common.booking':
          text_title = this.$t('common.booking')
          break
        case 'common.sendPdf':
          text_title = this.$t('common.sendPdf')
          break
        case 'common.pay':
          text_title = this.$t('common.pay')
          break
        case 'common.add_retail_service':
          text_title = this.$t('common.add_retail_service')
          break
        default:
          text_title = this.$t('common.printPdf')
          break;
      }
      return text_title
    },

    sortBy: function(key) {
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
    },
    setStatusField: function(key) {
      this.statusField = key;
    },
    verifyColumn: function(status) {
      let _status = "";
      if (status == 1) {
        _status = this.$t("apartment.open");
      } else if (status == 2) {
        _status = this.$t("apartment.issue");
      } else if (status == 3) {
        _status = this.$t("apartment.paid");
      } else if (status == 4) {
        _status = this.$t("report.cancelled");
      } else {
        _status = "Partial paid";
      }
      return _status;
    },
    performAction: function(data, actionsType, isModalVisible) {
      var self = this;
      self.actionsType = actionsType;
      self.recordData = data;
      self.isModalVisible = isModalVisible;
      self.$emit(
        "actions",
        self.recordData,
        self.actionsType,
        self.isModalVisible
      );
    },
    /**
     * Remove selected
     */
    removeSelected: function () {
      this.selected = []
      this.selectAll = false
    },
    filterDataOnTable: function() {
      var self = this;
      self.emitfilteredData = this.filteredData;
      self.$emit("filters", self.emitfilteredData);
      self.$emit("searchQuery", this.searchQuery);
    },
    onClickItemRow: function(entryId) {
      this.$emit("onClickItemRow", entryId);
    },
    stop: function(e) {
      e.stopPropagation();
    },
    checkItems: function(data) {
      this.$emit("selectedItems", this.selected, this.selectAll);
    },
    select: function() {
      this.selected = [];
      let data = [];
      data = this.filteredData;
      if (this.selectAll) {
        for (let i in data) {
          if (
            !utils.isNull(this.isGetInformationInvoice) &&
            this.isGetInformationInvoice
          ) {
            if (data[i].disableCheckbox !== undefined && !data[i].disableCheckbox) {
              this.selected.push(data[i]);
            } else if (data[i].disableCheckbox === undefined) {
              this.selected.push(data[i]);
            }
          } else {
            if (Object.keys(data[i]).includes("apartment.status")) {
              this.selected.push(data[i]["id"]);
            }
          }
        }
      }
      this.$emit("selectedItems", this.selected, this.selectAll);
    },
    selectAllIdInvoice: function () {
      this.selectAll = true
      this.select()
    },
    UnselectedAll: function(){
      this.selectAll = false
      this.select()
    },
    checkIsMonthCurrent: function(date) {
      var now = new Date();
      var check = new Date(date);
      if (check.getMonth() == now.getMonth()) return true;
      return false;
    },
    isInteger: function(str) {
      return typeof str === "number" && Math.round(str) == str;
    },
    isFloat: function(str) {
      return typeof str === "number" && !isInteger(str);
    },
    isDateString: function(str) {
      var regexDate = RegExp(
        "^[0-9]{2}[/][0-9]{2}[/][0-9]{4}.[0-9]{2}.+[0-9]+$"
      ); //  ^[0-9]+/[0-9]+/[0-9]+$
      return regexDate.test(str);
    },
    isNumber: function(str) {
      var regexDate = RegExp("^[0-9\\.,]+$");
      return regexDate.test(str);
    },
    changeBFormSelect: function(id, data){
      this.$emit("changeBFormSelect",id ,data);
    },
    getActionCustom: function(actionItemList, dataList) {
      let result = [...actionItemList]
      if (this.customActionKey !== undefined) {
        try {
          if (this.customActionKey.length > 0) {
            this.customActionKey.forEach(key => {
              let headerKey = key.headerKey
              if ( dataList[headerKey] !== undefined && (
                  ( dataList[headerKey] === key.headerKeyValue && key.isEqualHeaderKeyValue) ||
                  ( dataList[headerKey] !== key.headerKeyValue && !key.isEqualHeaderKeyValue)
                )
              ) {
                let index = result.indexOf(key.actionHide);
                if (index > -1) {
                  result.splice(index, 1);
                }
              }
            })
            return result
          } else {
            return []
          }
        }
        catch(err) {
          return []
        }
      } else {
        return result
      }
    }
  },
  components: {
    "lte-button": LTEButton,
    "lte-hyperlink": LTEHyperlink,
    Multiselect
  },
  created() {
    let sortOrders = {};
    if (this.columns[0]["text"]) {
      this.columns.forEach(function(key) {
        sortOrders[key.text] = 1;
      });
    } else {
      this.columns.forEach(function(key) {
        sortOrders[key] = 1;
      });
    }

    this.sortOrders = sortOrders;

    this.$emit("searchQuery", this.searchQuery);
  }
};
</script>

<style lang="scss" scoped>
.row_mouse_pointer {
  cursor: pointer;
}

.isVisibility {
  display: none;
}
table > th {
  cursor: pointer;
}
div .right-search {
  width: 300px;
  margin-bottom: 5px;
  float: right;
}

div .left-search {
  width: 300px;
  margin-bottom: 5px;
  float: left;
}

th,
td {
  min-width: 50px;
  padding: 5px 7px;
  // padding: 10px 20px;
}

th.active {
  color: aquamarine;
}

th.active .arrow {
  opacity: 1;
}

.arrow {
  display: inline-block;
  vertical-align: middle;
  width: 0;
  height: 0;
  margin-left: 5px;
  opacity: 0.66;
}

.arrow.asc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-bottom: 4px solid #fae042;
}

.arrow.dsc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 4px solid #fae042;
}

th.active .other_color_arrow {
  opacity: 1;
}

.other_color_arrow {
  display: inline-block;
  vertical-align: middle;
  width: 0;
  height: 0;
  margin-left: 5px;
  opacity: 0.66;
}

.other_color_arrow.asc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-bottom: 4px solid black;
}

.other_color_arrow.dsc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 4px solid black;
}

#grid-template {
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  -webkit-flex-direction: column;
  width: 600px;
}
.custom-box {
  border-radius: 3px;
  background: #ffffff;
  border: 1px solid #e6e9ed;
  border-bottom: 0px;
  margin-bottom: 2px;
  width: 100%;
  -webkit-box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
  box-shadow: 0 1px 0px rgba(0, 0, 0, 0.1);
}
.active_line {
  // wheat
  background-color: lightblue;
}

.active_line_invoice {
  background-color: #f1f1f1 !important;
}
.more-btn,
.more-menu-btn {
  border-radius: 5px;
  background-color: #c9302c;
  border: 0 none;
  // border-color: #ac2925;
  line-height: normal;
  overflow: visible;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  width: 100%;
  text-align: left;
  margin-bottom: 0px;
  outline: none;
  cursor: pointer;
}

.more-dot {
  background-color: white;
  margin: 0 auto;
  display: inline-block;
  width: 5px;
  height: 5px;
  margin-right: 1px;
  margin-bottom: 2px;
  border-radius: 50%;
  transition: background-color 0.3s;
}

.label-darkcyan {
  background-color: darkcyan !important;
}
.label-crimson {
  background-color: crimson !important;
}
.label-darkblue {
  background-color: darkblue !important;
}

.none {
  display: none;
}
.progress-custom {
  width: 150px;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/LTETable.vue